import type {FC} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {SearchLineIcon} from '~library/svg/SearchLineIcon';

import * as styles from './NoResultsHeader.module.scss';

interface NoResultsHeaderProps {
  onClearFilters: () => void;
}

export const NoResultsHeader: FC<NoResultsHeaderProps> = ({onClearFilters}) => (
  <div className={styles.noResultsHeaderWrapper}>
    <div className={styles.noResultsHeader}>
      <SearchLineIcon />
      <Typography variant="header4" color="charcoal">
        No results found
      </Typography>
      <Typography variant="paragraph2" color="charcoal">
        Tip: try a different search or adjust your filters!
      </Typography>
    </div>
    <Button
      variant="secondary"
      size="medium"
      onClick={onClearFilters}
      data-qa-id="galleryNoResultsClearFiltersButton"
      disableProcessing
    >
      Clear filters
    </Button>
  </div>
);
